import React, { useEffect, useState } from 'react';
import '../../../common/components/GovtTaxTileContent/GovtTaxTileContent.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import CustomAcceptButton from '../../../common/components/CustomSmallButtons/CustomAcceptButton';
import CustomCancelButton from '../../../common/components/CustomSmallButtons/CustomCancelButton';
interface contentTileType {
  taxName?: string;
  complaintBy?: string;
  description?: any;
  onClickAccept: any;
  onClickReject: any;
}
const ComplaintContent: React.FC<contentTileType> = ({
  taxName,
  complaintBy,
  description,
  onClickAccept,
  onClickReject,
}) => {
  const { t } = useTranslation();
  const trans = t;

  return (
    <Grid container className="govtTax-container">
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.title,
          fontFamily: fonts.fontFamily,
          color: themes.blackDefault,
          fontWeight: 'bold',
          textTransform: 'capitalize',
          display: 'flex',
        }}
      >
        {taxName}
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textTransform: 'capitalize',
          letterSpacing: '0.01px',
          marginTop: '10px',
        }}
      >
        {trans('Complaint By')}:{' '}
        <span style={{ color: themes.blackDefault }}>{complaintBy}</span>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textTransform: 'capitalize',
          letterSpacing: '0.01px',
          marginTop: '10px',
        }}
      >
        {trans('Description ')} :{' '}
        <span style={{ color: themes.blackDefault }}>{description}</span>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginTop: '10px',
        }}
      >
        <CustomCancelButton onClickCancel={onClickReject} title={'REJECT'} />
        <CustomAcceptButton
          onClickSubmit={onClickAccept}
          title={'ACCEPT'}
          textTransform="uppercase"
        ></CustomAcceptButton>
      </Grid>
    </Grid>
  );
};

export default ComplaintContent;
